import React from "react";
import { ToggleButton } from "./../../../ui-components";
import styles from "./list-item-toggle-scss";
const ListItemToggle = ({
  title,
  infoContent,
  dataHook,
  selected,
  onChange,
  disabled
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.container }, /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      title,
      checked: selected,
      onChange,
      infoContent,
      dataHook,
      size: "small",
      disabled
    }
  ));
};
var ListItemToggle_default = ListItemToggle;
export {
  ListItemToggle_default as default
};
//# sourceMappingURL=ListItemToggle.js.map
